<template>
    <div class="viewLFSIS">
        <div class="modal-conteudo">
            <div id="divImprimir" v-if="dados.legislacao">
                <h3>{{ dados.legislacao.nmTitulo }}</h3>
                <p class="subtituloLei"
                   v-if="dados.legislacao.dsLegislacao"
                   v-html="dados.legislacao.dsLegislacao.replace('\r\n','<br />')"></p>
                <div id="htmlLegislacao" v-html="htmlLegislacao" @click="handleClick"></div>
            </div>
        </div>

        <div class="modal-footer">
            <p class="origem" v-if="dados.legislacao">{{ dados.legislacao.nmTitulo }}</p>
            <div class="acoes">
                <button class="btn-imprimir" type="button" @click="imprimir">
                    <i class="fas fa-print"></i> Imprimir
                </button>
            </div>
        </div>
    </div>
</template>

<script>
    import { cssImpressaoLei } from './leiAnotacao'
    import { normalizarLinksConteudoNoHtml, navegarLinkConteudo } from '@/utils/linksPortalAntigo'

    export default {
        name: 'viewLFSIS',
        props: {
            dados: Object,
        },
        computed: {
            htmlLegislacao() {
                return normalizarLinksConteudoNoHtml(this.dados.legislacao?.htmlLegislacao || '')
            },
        },
        methods: {
            handleClick(e) {
                navegarLinkConteudo(e, this.$router)
            },
            imprimir() {
                const html = document.getElementById('divImprimir').innerHTML + cssImpressaoLei()
                const tela_impressao = window.open('about:blank')
                tela_impressao.document.write(html)
                tela_impressao.window.print()
                tela_impressao.window.close()
            },
        }
    }
</script>

<style scoped lang="scss">
    @import "@/assets/css/lei-comentada/view-legislacao";
    .viewLFSIS { @include lei-comentada-view; }
</style>
